export const imageCodes = {

    sliderOne: {
        code: "${merchantId}_tmpl_img_1",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fwil%20slider%20update%202.jpg?alt=media&token=63c90cdc-7fed-47aa-90c9-8aaf93c57116"
    },

    sliderThree: {
        code: "${merchantId}_tmpl_img_2",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fwillow_slider_3.jpg?alt=media&token=89420969-1f1d-45e0-90ac-0add67d07a94"
    },

    featurePhoto2: {
        code: "${merchantId}_tmpl_img_3",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FINF04554.jpg?alt=media&token=ef89765b-cb79-4e12-88cd-76f2cfae1f5b"
    },

    featurePhoto1: {
        code: "${merchantId}_tmpl_img_4",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FINF04776.jpg?alt=media&token=0944a596-c050-4591-ae53-93d313ac8fae"
    },

    featurePhoto3: {
        code: "${merchantId}_tmpl_img_5",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FINF04918.jpg?alt=media&token=718b7d6c-c047-4f3c-95dc-17dc8a8302be"
    },

    featurePhoto4: {
        code: "${merchantId}_tmpl_img_6",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FINF05030.jpg?alt=media&token=7e107ff6-9227-4949-b3a7-f51992d3792b"
    },

    featurePhoto5: {
        code: "${merchantId}_tmpl_img_7",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FINF05091.jpg?alt=media&token=16c528e4-8dd7-449f-b2f8-2f1e3e5daa7f"

    },

    featurePhoto6: {
        code: "${merchantId}_tmpl_img_8",

        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FINF05134.jpg?alt=media&token=d335eb27-d821-40d5-885b-927aea9bfeab"

    },

    featurePhoto7: {
        code: "${merchantId}_tmpl_img_9",

        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fpick.jpg?alt=media&token=c54ca745-c2dc-4272-a7f3-615a95a077cf"
    },
    
    feature2: {
        code: "${merchantId}_tmpl_img_10",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fboy.jpg?alt=media&token=d60411c5-8c18-4157-8b62-f9a1fcc084f5"
    },

    feature1: {
        code: "${merchantId}_tmpl_img_13",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fwoman.jpg?alt=media&token=96d38484-2f3c-4cf0-82d0-bbad45f9f218"
    },

    feature3: {
        code: "${merchantId}_tmpl_img_15",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fgirl.jpg?alt=media&token=47bd206c-a373-4329-b1ee-126b0a5b9198"
    },
    
    whoWeAre: {
        code: "${merchantId}_tmpl_img_16",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Four.jpg?alt=media&token=d31bdfb5-219b-48df-86ee-d1a403c6587d"
    },
    
    weDo: {
        code: "${merchantId}_tmpl_img_17",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Four1.jpg?alt=media&token=99a18385-bfaa-4368-b965-d2fa23a770ed"
    },

    trackOrder: {
        code: "${merchantId}_tmpl_img_18",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FTrack%20your%20order%20(1).jpg?alt=media&token=cfe57adc-b66c-41d0-aded-f0a3407a4560"
    },

    mediaRoom: {
        code: "${merchantId}_tmpl_img_19",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flanding%206%20(1).jpg?alt=media&token=2afd901d-e42a-4620-aa93-0e189e43bbfc"
    },

    sliderTwo: {
        code: "${merchantId}_tmpl_img_20",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fwil%20slider%20up%204.png?alt=media&token=a07e616e-fc7f-4d13-8755-0500ecfbb4e7"
    },

    whoWeAre1: {
        code: "${merchantId}_tmpl_img_21",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Four.jpg?alt=media&token=906f19db-81ed-45b4-9aff-e6990c8eef46"
    },

    review1: {
        code: "${merchantId}_tmpl_img_22",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcustomer%20reviews1.jpeg?alt=media&token=46a0ce2e-08f8-4338-a7bb-9af540520037"
    },

    review2: {
        code: "${merchantId}_tmpl_img_23",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcustomer%20reviews2.jpeg?alt=media&token=cbb0b65a-9393-42ab-aeb5-cdda6a104d6a"
    },

    review3: {
        code: "${merchantId}_tmpl_img_25",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcustomer%20reviews3.jpeg?alt=media&token=083ced43-cf75-4c8a-95b3-95bc4b3fe2be"
    },

    review4: {
        code: "${merchantId}_tmpl_img_26",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcustomer%20reviews5.jpeg?alt=media&token=f409faca-2d18-4540-9270-a72092341460"
    },
    
    review14: {
        code: "${merchantId}_tmpl_img_27",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FIMG_1821.jpg?alt=media&token=1f6fe552-c000-49e5-bbd0-9acfb66a1008"
    },
    
    review16: {
        code: "${merchantId}_tmpl_img_28",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Freview.png?alt=media&token=df08b6ec-526c-467e-ab20-a6ca20788308"
    },

    review5: {
        code: "${merchantId}_tmpl_img_29",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcustomer%20reviews7.jpeg?alt=media&token=7890d7e4-7aad-43c4-a721-d04bd3ad9cf6"
    },

    review6: {
        code: "${merchantId}_tmpl_img_30",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcustomer%20reviews8.jpeg?alt=media&token=4a09b476-b1fa-4b43-b0e2-b1f5be01e5ec"
    },

    review7: {
        code: "${merchantId}_tmpl_img_31",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcustomer%20reviews9.jpeg?alt=media&token=d1c49c65-4e4c-4bf4-8c7c-63710d7cfc26"
    },

    review8: {
        code: "${merchantId}_tmpl_img_32",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcustomer%20reviews10.jpeg?alt=media&token=1628688f-c5a1-4c3c-8d46-818e6315fe4e"
    },

    review9: {
        code: "${merchantId}_tmpl_img_33",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcustomer%20reviews11.jpeg?alt=media&token=1f857dd4-7585-4789-8e6d-f93398c3be55"
    },

    review10: {
        code: "${merchantId}_tmpl_img_34",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcustomer%20reviews12.jpeg?alt=media&token=ee991072-4464-4f08-b519-7e762ca33c92"
    },

    review11: {
        code: "${merchantId}_tmpl_img_35",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcustomer%20reviews13.jpeg?alt=media&token=fd0425eb-9479-446f-b828-adf050e99495"
    },

    review12: {
        code: "${merchantId}_tmpl_img_36",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcustomer%20reviews14.jpeg?alt=media&token=e82da27c-96bf-4b5c-a279-8047453b3829"
    },

    review13: {
        code: "${merchantId}_tmpl_img_37",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcustomer%20reviews15.jpeg?alt=media&token=6cdce069-517d-4e8a-be35-917d4fb6d269"
    },

    review15: {
        code: "${merchantId}_tmpl_img_38",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcustomer%20reviews16.jpeg?alt=media&token=b6c20b53-2f97-46e9-b810-7148536a2f66"
    },
    
    featurePhoto8: {
        code: "${merchantId}_tmpl_img_39",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FKAW_8777.jpg?alt=media&token=36e09b00-b30b-447e-bc08-2206a041b307"
    },

    featurePhoto9: {
        code: "${merchantId}_tmpl_img_40",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FKAW_8814.jpg?alt=media&token=f3114283-a705-48a7-9a38-a0623419478e"
    },

    featurePhoto10: {
        code: "${merchantId}_tmpl_img_41",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FKAW_8852.jpg?alt=media&token=565593a3-281d-46be-b716-eb5ad79f76e9"
    },

    featurePhoto11: {
        code: "${merchantId}_tmpl_img_42",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Ffeature4.png?alt=media&token=dc5cf04e-23b9-4100-b754-3b9ec782fd1a"
    },

    featurePhoto12: {
        code: "${merchantId}_tmpl_img_43",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Ffeature1.png?alt=media&token=5e2eab99-eba7-407a-a796-da4ae498cae4"
    },

    featurePhoto13: {
        code: "${merchantId}_tmpl_img_44",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Ffeature1.png?alt=media&token=18396ad8-0842-42ef-af59-73bce98680de"
    },

    featurePhoto14: {
        code: "${merchantId}_tmpl_img_45",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FKAW_9569.jpg?alt=media&token=7472f11d-803b-4c79-9731-b42de5cabd1b"
    },

    featurePhoto15: {
        code: "${merchantId}_tmpl_img_46",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FKAW_9596.jpg?alt=media&token=d0de8fb6-04e8-4bf8-bcee-af9c82a821d9"
    },

    featurePhoto16: {
        code: "${merchantId}_tmpl_img_47",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FKAW_9640.jpg?alt=media&token=3619aa13-7995-4be7-a86f-05313c3b2c32"
    },

    featurePhoto17: {
        code: "${merchantId}_tmpl_img_48",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FKAW_9705.jpg?alt=media&token=bc11870e-5f72-4d22-bd20-6a19aeafa0ab"
    },
 
    feature4: {
        code: "${merchantId}_tmpl_img_49",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fman.jpg?alt=media&token=538ac7f7-c3cf-4f71-8698-15737bf884c2"
    },

    newfeature1: {
        code: "${merchantId}_tmpl_img_50",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fnewfeature1.png?alt=media&token=93ca5474-529e-4407-8af0-ed874194e3ed"
    },

    newfeature2: {
        code: "${merchantId}_tmpl_img_11",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fnewfeature22.png?alt=media&token=c8e1a2a8-2c70-4368-974e-ed3d5ef02591"
    },

    newfeature3: {
        code: "${merchantId}_tmpl_img_12",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fnewfeature3.png?alt=media&token=50ef3df5-6b86-4814-8a84-0fc563423a1a"
    },

    newfeature4: {
        code: "${merchantId}_tmpl_img_14",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fnewfeature4.png?alt=media&token=c33fd8b2-be77-417b-a44e-dbf4b9fe0f71"
    },

}

export const titleCodes = {
    ourProduct: {
        code: "${merchantId}_tmpl_title_1",
        title: "shop our products",
    },

    ourStory: {
        code: "${merchantId}_tmpl_title_2",
        title: "our story",
    },

    whoTitle: {
        code: "${merchantId}_tmpl_title_3",
        title: "who we are",
    },

    doTitle: {
        code: "${merchantId}_tmpl_title_4",
        title: "what we do",
    },

    featurePhotos: {
        code: "${merchantId}_tmpl_title_5",
        title: "featured photos",
    },

    trackYourOrder: {
        code: "${merchantId}_tmpl_title_6",
        title: "shipping",
    },
    mediaRoomTitle: {
        code: "${merchantId}_tmpl_title_7",
        title: "media room",
    },
    prettyCustomers: {
        code: "${merchantId}_tmpl_title_12",
        title: "customer reviews",
    },
    ourProductMM: {
        code: "${merchantId}_tmpl_title_1",
        title: "shop our products",
    },

    ourStoryMM: {
        code: "${merchantId}_tmpl_title_2",
        title: "our story",
    },

    whoTitleMM: {
        code: "${merchantId}_tmpl_title_3",
        title: "who we are",
    },

    doTitleMM: {
        code: "${merchantId}_tmpl_title_4",
        title: "what we do",
    },

    featurePhotosMM: {
        code: "${merchantId}_tmpl_title_5",
        title: "featured photos",
    },

    trackYourOrderMM: {
        code: "${merchantId}_tmpl_title_6",
        title: "track your order",
    },

    mediaRoomTitleMM: {
        code: "${merchantId}_tmpl_title_7",
        title: "media room",
    },
    prettyCustomersMM: {
        code: "${merchantId}_tmpl_title_12",
        title: "customer reviews",
    },
}

export const textCodes = {

    story1: {
        code: "${merchantId}_tmpl_text_16",
        text: "Inspired by “Minimalism”, our brand treasures living life with simplicity and elegance. We believe in quality over quantity and we aim to go for simple and versatile designs so you can wear them for various occasions and never go out of style."
    },

    story3: {
        code: "${merchantId}_tmpl_text_17",
        text: "Our design ethos is to strive in bringing quality products with an affordable price that will endure the test of time."
    },

    wedo1: {
        code: "${merchantId}_tmpl_text_18",
        text: "We provide products that are curated with simplicity in mind and created with quality for kids, women and men. Each collection contains versatile yet elegant pieces in limited handpicked fabric designed to last for a long time."
    },

    wedo2: {
        code: "${merchantId}_tmpl_text_19",
        text: "As a business, we are constantly re-evaluating our work in an effort to better contribute to our local community and act in a way that is socially and environmentally responsible. We work with local talents to promote our economy and culture."
    },

    womenText: {
        code: "${merchantId}_tmpl_text_9",
        text: 'Simple and minimal pieces designed for any kind of occasion.'
    },

    boyText: {
        code: "${merchantId}_tmpl_text_7",
        text: 'Smart and fun pieces for your dearest boy.'
    },

    girlText: {
        code: "${merchantId}_tmpl_text_8",
        text: 'Elegant pieces to style your little girl.'
    },

    manText: {
        code: "${merchantId}_tmpl_text_20",
        text: 'Comfortable and smart casual pieces for weekday or weekend outing.'
    },

    shopText: {
        code: "${merchantId}_tmpl_title_6",
        text: "shop"
    },
    myanmar: {
        code: "${merchantId}_tmpl_text_15",
        text: '– မြန်မာ'
    },
    story1MM: {
        code: "${merchantId}_tmpl_text_1",
        text: "“Minimalism” ကို အခြေပြုဖန်တီးထားတဲ့ Willow Clothing brand ဟာ elegant ဖြစ်ပြီး ရိုးရှင်းစွာ ရှင်သန်ရတဲ့ lifestyle ကို တန်ဖိုးထားပါတယ်။ အဲဒီ့အတွက်ကြောင့် Willow brand မှထွက်ရှိမယ့် အဝတ်အစားများကလဲ Versatile ဖြစ်ပြီး ကိုယ်ပိုင် style အမျိုးမျိုး ပြောင်းလဲကာ ဘယ်နေရာမဆို ဝတ်ဆင်နိုင်ရန် ကျွန်မတို့ founder ၂ ယောက်က ရည်ရွယ်ပြီး ထုတ်လုပ်ထားပါတယ်။"
    },

    story3MM: {
        code: "${merchantId}_tmpl_text_3",
        text: "Willow ရဲ့ ခံယူချက် ကတော့ “quality over quantity” ဖြစ်တဲ့ အတွက် မြန်မာနိုင်ငံရဲ့ ရာသီဥတုနဲ့ လိုက်ဖက်ပြီး အရည်အသွေးမြင့်တဲ့ fabric များကိုသာအသုံးပြုထားပါတယ်။ ဒီဇိုင်းအနေနဲ့ ဆိုရင်လဲ ကြာရှည်ခံပြီး ဘယ်တော့မဆို ရိုးမသွားမယ့် product design များကိုသာ ဖန်တီးပေးနိုင်အောင် အမြဲတမ်းကြိုးစားသွားမှာဖြစ်ပါတယ်။"
    },

    wedo1MM: {
        code: "${merchantId}_tmpl_text_4",
        text: "Simplicity & Quality ကို အမြဲတမ်း နံပါတ် ၁ နေရာထားပြီး ထုတ်လုပ်ထား တဲ့ Willow ရဲ့ clothing line လေးကတော့ မေမေ, ဖေဖေ နဲ့ ကလေးငယ်လေးများအတွက် အဓိကရည်ရွယ်ထားပြီး versatile ဖြစ်စေမယ့် matching apparels လေးများစွာကို collection တစ်ခုချင်းစီ ထွက်ရှိမှာ ဖြစ်ပါတယ်။"
    },

    wedo2MM: {
        code: "${merchantId}_tmpl_text_5",
        text: "Willow ရဲ့ matching apparels လေးတွေကို တူတူဝတ်ပြီး တန်ဖိုးရှိတဲ့အမှတ်တရလေးတွေကို ဖန်တီရင်း မေမေ ဖေဖေတို့ နဲ့ ကလေးငယ်တွေကြားမှာရှိတဲ့ ရင်းနှီးမှု သံယောဇဉ် bond လေး ပိုမိုခိုင်မာလာစေဖို့ အတွက် Willow Clothing Brand လေးကို ဖန်တီးထားပါတယ်။"
    },

    womenTextMM: {
        code: "${merchantId}_tmpl_text_9",
        text: 'Designed for any kind of occassion, whether you are a mother or not.'
    },

    boyTextMM: {
        code: "${merchantId}_tmpl_text_7",
        text: 'Smart and fun pieces for your dearest boy.'
    },

    girlTextMM: {
        code: "${merchantId}_tmpl_text_8",
        text: 'Elegant pieces to style your little girl.'
    },

    shopTextMM: {
        code: "${merchantId}_tmpl_title_6",
        text: "shop"
    },
    eng: {
        code: "${merchantId}_tmpl_text_14",
        text: '– English'
    },

}